import React, { useState, useContext } from "react";
import { Link as RouterLink, useLocation, useHistory } from "react-router-dom";
import { 
  Container, 
  CssBaseline, 
  Typography, 
  Button, 
  TextField, 
  Paper,
  CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { LockOutlined } from "@material-ui/icons";
import { openApi } from "../../services/api";
import ColorModeContext from "../../layout/themeContext";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#00B2FF",
    backgroundImage: "linear-gradient(326deg, rgba(0, 178, 255, 1) 0%, rgba(0, 70, 249, 1) 50%, rgba(0, 4, 25, 1) 100%)",
  },
  paper: {
    padding: theme.spacing(6),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "16px",
    textAlign: "center",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: "10px 30px",
    borderRadius: "8px",
  },
}));

const PasswordReset = () => {
  const classes = useStyles();
  const { colorMode } = useContext(ColorModeContext);
  const { appName, appLogoFavicon } = colorMode;
  const history = useHistory();
  
  const location = useLocation();
  const useQuery = () => new URLSearchParams(location.search);
  const query = useQuery();
  const token = query.get("token");
  const email = query.get("email");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || !confirmPassword) return toast.error("Preencha todos os campos.");
    if (password !== confirmPassword) return toast.error("As senhas não coincidem.");
    if (password.length < 5) return toast.error("A senha deve ter no mínimo 5 caracteres.");

    setLoading(true);
    try {
      await openApi.post("/auth/password-reset", { email, token, password });
      toast.success("Senha atualizada com sucesso!");
      history.push("/login");
    } catch (err) {
      toast.error(err.response?.data?.error || "Token inválido ou expirado.");
    }
    setLoading(false);
  };

  if (!token || !email) {
    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Typography variant="h6" color="error">Link Inválido</Typography>
          <Typography variant="body2" style={{ marginTop: 8, marginBottom: 16 }}>
            O link de redefinição de senha está incompleto ou ausente.
          </Typography>
          <Button component={RouterLink} to="/password-forget" variant="outlined" color="primary">Solicitar novo link</Button>
        </Paper>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{appName || "CliqBR"} - Nova Senha</title>
        <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"} />
      </Helmet>
      <Container component="main" maxWidth="xs" style={{ display: "flex", justifyContent: "center" }}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <LockOutlined style={{ fontSize: 60, color: "#0067E3", marginBottom: 16 }} />
          <Typography variant="h5" gutterBottom>Definir Nova Senha</Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>Crie uma nova senha para a conta: <br /><strong>{email}</strong></Typography>
          <form style={{ width: "100%" }} onSubmit={handleSubmit}>
            <TextField variant="outlined" margin="normal" required fullWidth name="password" label="Nova Senha" type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <TextField variant="outlined" margin="normal" required fullWidth name="confirmPassword" label="Confirmar Nova Senha" type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} disabled={loading}>{loading ? <CircularProgress size={24} color="inherit" /> : "Salvar e Entrar"}</Button>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default PasswordReset;
